/* Allbag: status pracy doradców (Europe/Warsaw, pon.-pt. w godzinach z data-from / data-to) */
(function () {
  'use strict';
  var HOL = { '01-01': 1, '01-06': 1, '05-01': 1, '05-03': 1, '08-15': 1, '11-01': 1, '11-11': 1, '12-24': 1, '12-25': 1, '12-26': 1 };
  function warsaw() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Warsaw', weekday: 'short', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    var o = {}; f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    var days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
    return { dow: days[o.weekday], h: +o.hour, m: +o.minute, md: o.month + '-' + o.day };
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function apply(el) {
    var from = parseFloat(el.getAttribute('data-from') || '7'), to = parseFloat(el.getAttribute('data-to') || '15');
    var t = warsaw(), now = t.h + t.m / 60;
    var workday = t.dow >= 1 && t.dow <= 5 && !HOL[t.md];
    var online = workday && now >= from && now < to;
    el.classList.toggle('is-online', online);
    el.classList.toggle('is-offline', !online);
    var txt = el.querySelector('[data-ab-status-text]');
    if (!txt) return;
    if (online) { txt.textContent = el.getAttribute('data-online') || ''; return; }
    var back = el.getAttribute('data-back') || '';
    var names = (el.getAttribute('data-days') || '').split('|');
    var d = t.dow, add = 0;
    if (workday && now < from) add = 0; else { add = 1; while (true) { var nd = (d + add) % 7; if (nd >= 1 && nd <= 5) break; add++; if (add > 7) break; } }
    var label = add === 0 ? (el.getAttribute('data-today') || '') : (add === 1 ? (el.getAttribute('data-tomorrow') || '') : (names[(d + add) % 7] || ''));
    txt.textContent = back.replace('{d}', label).replace('{h}', Math.floor(from) + ':' + pad(Math.round((from % 1) * 60)));
  }
  function boot() { document.querySelectorAll('[data-ab-status]').forEach(apply); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  setInterval(boot, 60000);
})();
